import PropTypes from 'prop-types';

export default {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  item_number: PropTypes.string,
  description: PropTypes.string,
  price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  total: PropTypes.number,
  errors: PropTypes.shape({
    price: PropTypes.array,
    quantity: PropTypes.array,
    line_item: PropTypes.array,
    note: PropTypes.array,
  }),
  status: PropTypes.string,
  po_number: PropTypes.string,
  phase_line_item_id: PropTypes.number,
  warehouse_quantity: PropTypes.shape({
    remainder: PropTypes.number,
    packages: PropTypes.number,
  }),
  warehouse_status: PropTypes.string,
  payable: PropTypes.bool,
  note: PropTypes.string,
  net_quantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};



// WEBPACK FOOTER //
// ./client/app/shared/types/lineItemPropType.js